import { useEffect, useState } from "react";
import { ProductImage } from "@/components/ProductCard";
import { img } from "@/lib/api";

export const Gallery = ({ images = [] }) => {
  const [i, setI] = useState(0);
  useEffect(() => {
    setI(0);
  }, [images]);
  return (
    <div className="min-w-0 lg:sticky lg:top-36 lg:self-start" data-testid="product-gallery">
      <div className="aspect-square overflow-hidden rounded-3xl border border-slate-200 bg-white">
        <ProductImage image={images[i]} className="p-8" />
      </div>
      {images.length > 1 && (
        <div className="no-scrollbar mt-4 flex gap-3 overflow-x-auto">
          {images.map((im, k) => (
            <button key={im.url} onClick={() => setI(k)} data-testid={`gallery-thumb-${k}`} aria-label={`Foto ${k + 1}`}
              className={`h-20 w-20 shrink-0 overflow-hidden rounded-xl border-2 bg-white transition-colors ${k === i ? "border-[#0066FF]" : "border-slate-200 opacity-70 hover:opacity-100"}`}>
              <img src={img(im.url)} alt="" loading="lazy" className="h-full w-full object-contain p-1.5" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
